module.exports = {"name":"name","address":"address","mobile_number":"$t(phone:mobile_number)","date_of_birth":"$t(birthdate:date_of_birth)"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/flowConfirmation.json
// module id = 523
// module chunks = 245 975